import { Routes } from '@angular/router';

export const routes: Routes = [
  // 1. RUTA DEL CRM (AISLADA Y CON CARGA DIFERIDA)
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },

  {
    path: '',
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    title: 'Ron y Whisky Artesanal de los Andes | Estancos Distilling Co.',
    data: {
      description: 'Descubre nuestros destilados premium madurados a 2500 msnm. Ron añejo y whisky andino elaborados con pasión y tradición en Ecuador.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/fotosFondoEstancosall.jpeg'
    }
  },
  {
    path: 'espiritus',
    loadComponent: () => import('./pages/spirits-page/spirits-page').then(m => m.SpiritsPage),
    title: 'Nuestra Colección de Espíritus | Estancos',
    data: {
      description: 'Explora las notas de cata y la historia detrás de nuestro ron y whisky. Destilados de clase mundial, moldeados por la altura.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/espiritus/whiskey-60-ecommerce.jpeg'
    }
  },
  {
    path: 'espiritus/ron-legarda',
    loadComponent: () => import('./pages/ron-legarda-page/ron-legarda-page').then(m => m.RonLegardaPage),
    title: 'Ron Estancos Legarda | Estancos Distilling Co.',
    data: {
      description: 'Descubre el Ron Estancos Legarda. Añejado a 2500 msnm en barricas de roble americano ex-bourbon. Notas de cata, historia y compra directa.',
      ogImage: 'https://images.unsplash.com/photo-1527281400683-1aae777175f8?q=80&w=1000&auto=format&fit=crop'
    }
  },
  {
    path: 'ron-estancos-legarda',
    redirectTo: 'espiritus/ron-legarda',
    pathMatch: 'full'
  },
  {
    path: 'espiritus/whisky-real-audiencia',
    loadComponent: () => import('./pages/whisky-real-audiencia-page/whisky-real-audiencia-page').then(m => m.WhiskyRealAudienciaPage),
    title: 'Whisky Real Audiencia Single Malt | Estancos Distilling Co.',
    data: {
      description: 'Descubre el Whisky Real Audiencia Single Malt. El primer whisky andino destilado a 2500 msnm con malta seleccionada y agua de glaciar.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/espiritus/whiskey-60-ecommerce.jpeg'
    }
  },
  {
    path: 'whisky-real-audiencia',
    redirectTo: 'espiritus/whisky-real-audiencia',
    pathMatch: 'full'
  },
  {
    path: 'espiritus/whiskey-chillos-valley',
    loadComponent: () => import('./pages/whiskey-chillos-valley-page/whiskey-chillos-valley-page').then(m => m.WhiskeyChillosValleyPage),
    title: 'Whiskey Chillos Valley Grain | Estancos Distilling Co.',
    data: {
      description: 'Descubre el Whiskey Chillos Valley Grain. Destilado artesanal de granos andinos madurado a 2500 msnm.',
      ogImage: 'https://images.unsplash.com/photo-1527281400683-1aae777175f8?q=80&w=1000&auto=format&fit=crop'
    }
  },
  {
    path: 'whiskey-chillos-valley',
    redirectTo: 'espiritus/whiskey-chillos-valley',
    pathMatch: 'full'
  },
  {
    path: 'whisky-chillos-valley',
    redirectTo: 'espiritus/whiskey-chillos-valley',
    pathMatch: 'full'
  },
  {
    path: 'rommeliers',
    loadComponent: () => import('./pages/rommeliers-page/rommeliers-page').then(m => m.RommeliersPage),
    title: 'Nuestros Rommeliers | Fundadores y Maestros Destiladores de Estancos',
    data: {
      description: 'Conoce a los visionarios detrás de Estancos Distilling Co. Nuestros rommeliers combinan tradición y técnica para crear destilados excepcionales y sus procesos de creación.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/RichardMaster.jpeg'
    }
  },
  {
    path: 'contenidos',
    loadComponent: () => import('./pages/contenidos-page/contenidos-page').then(m => m.ContenidosPage),
    title: 'Universo Estancos | Historias, Recetas y Cultura del Ron y Whisky',
    data: {
      description: 'Adéntrate en nuestra cultura. Descubre los momentos capturados, aprende a mezclar como un maestro, encuentra el maridaje perfecto y acompáñanos en nuestros próximos eventos exclusivos.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/galleryImages/whiskyCentroH.jpeg'
    }
  },
  {
    path: 'visitas',
    loadComponent: () => import('./pages/visitas-page/visitas-page').then(m => m.VisitasPage),
    title: 'Enoturismo y Catas en Quito | Estancos Distilling Co.',
    data: {
      description: 'Reserva tu recorrido por nuestra destilería. Conoce la sala de alambiques, las bodegas y disfruta de una cata exclusiva de la barrica a la copa.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/views/destileriaEcommerce.jpeg'
    }
  },
  {
    path: 'tienda',
    loadComponent: () => import('./pages/tienda-page/tienda-page').then(m => m.TiendaPage),
    title: 'Boutique Online | Comprar Destilados Estancos',
    data: {
      description: 'Compra en línea nuestro Ron Añejo, Whisky Single Malt y accesorios. Envíos a todo el país directamente desde nuestra destilería.',
      ogImage: 'https://qgbwjkjgnyaynctlqxvq.supabase.co/storage/v1/object/public/product-images/1777317752257-iaqtod14t6.jpeg'
    }
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/cart-page/cart-page').then(m => m.CartPage),
    title: 'Carrito de Compras | Estancos Distilling Co.',
    data: {
      description: 'Revisa los productos que has seleccionado para comprar. Actualiza tus cantidades o elimina artículos antes de proceder al checkout.'
    }
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout-page/checkout-page').then(m => m.CheckoutPage),
    title: 'Checkout | Estancos Distilling Co.',
    data: {
      description: 'Completa tu compra y proporciona los detalles de envío y pago.'
    }
  }
];
